import angular from 'angular';
import ConnectionStatusDirective from './connection-status.directive';

let ConnectionStatusModule = angular.module('connection-status-module', [])

    .directive('connectionStatus', ConnectionStatusDirective)

    .name;

export default ConnectionStatusModule;


// WEBPACK FOOTER //
// ./client/app/common/connection-status/index.js